import {useState} from 'react'
import {
  DataAggregationSubTitle,
  StyledDiv,
  StyledErrorOutline,
  StyledTooltip,
  StyledIconButton,
  StyledCheckbox
} from './DataAggregationStyle'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import {ErrorMessage} from '../../common/MulitSelectDropdown/MultiSelectDropdownComponentStyle'
import PropTypes from 'prop-types'
import {useConfig} from '../../../store/hooks/config'
import {StyledSectionTitle} from '../../AdminPanelStyling'

const DataAggregation = ({selectedData, setSelectedDataAggregation, isCompleted}) => {
  DataAggregation.propTypes = {
    selectedData: PropTypes.array.isRequired,
    setSelectedDataAggregation: PropTypes.func.isRequired,
    isCompleted: PropTypes.bool.isRequired
  }

  const {dataAggregationConfig} = useConfig() || {}
  const isSelected = selectedData?.map((data) => data.value)

  if (
    isSelected?.length >= 1 &&
    !isSelected?.includes('State') &&
    !isSelected?.includes('County') &&
    !isSelected?.includes('US Congressional District') &&
    !isSelected?.includes('Census Tract')
  ) {
    setSelectedDataAggregation([])
  }
  const mainHeading = 'What level(s) of data granularity do you want available?'
  const subHeading = `This is the level of aggregation your client will see across all Health Condition and Social Drivers of Health (SDOH) selections on their dashboard.`
  const householdTooltipText =
    'Household data is PII and requires HealthPrism leadership approval. (Select either State or County or Census Tract or US Congressional District to enable Household)'
  const concentrationTooltipText =
    'This map layer uses known data points to visualize approximate household locations across an area. Individual households are masked to protect PII. (Select either State or County or Census Tract or US Congressional District to enable Household)'
  const handleChechboxChange = (e, data) => {
    if (e.target.checked) {
      setSelectedDataAggregation((current) => [...current, data])
    } else {
      setSelectedDataAggregation(
        selectedData?.filter((option) => {
          return option.key !== data.key
        })
      )
    }
  }
  const [isHouseholdToolTipOpen, setIsHouseholdToolTipOpen] = useState(false)
  const handleHouseholdClickAway = () => {
    setIsHouseholdToolTipOpen(false)
  }
  const [isConcentrationToolTipOpen, setIsConcentrationToolTipOpen] = useState(false)
  const handleConcentrationClickAway = () => {
    setIsConcentrationToolTipOpen(false)
  }

  const ariaLabelHouseholdToolTip = isHouseholdToolTipOpen
    ? householdTooltipText
    : 'Toggle Individual Households tooltip'
  const ariaLabelConcentrationToolTip = isConcentrationToolTipOpen
    ? concentrationTooltipText
    : 'Toggle Household Concentration tooltip'

  const aggregationList = dataAggregationConfig?.data?.map((data) => (
    <StyledDiv key={data.key}>
      <FormControlLabel
        key={data.key}
        control={
          <StyledCheckbox
            checked={isSelected?.includes(data.value) || false}
            onClick={(e) => handleChechboxChange(e, data)}
            checkedIcon={<CheckBoxIcon variant='checkBoxIcon' />}
            data-testid={`${data.value}-checkbox`}
            disabled={
              (data.value === 'Individual Households' || data.value === 'Household Concentration') &&
              !(
                isSelected?.includes('County') ||
                isSelected?.includes('State') ||
                isSelected?.includes('US Congressional District') ||
                isSelected?.includes('Census Tract')
              )
            }
          />
        }
        sx={{
          '& .MuiFormControlLabel-label': {fontSize: (theme) => theme.typography.labelLarge.fontSize},
          '& .MuiSvgIcon-root': {fontSize: (theme) => theme.typography.h4.fontSize}
        }}
        label={data?.value}
      />
      {(data.value === 'Individual Households' || data.value === 'Household Concentration') && (
        <StyledTooltip
          enterTouchDelay={0}
          title={data.value === 'Individual Households' ? householdTooltipText : concentrationTooltipText}
          tabIndex={0}
          open={data.value === 'Individual Households' ? isHouseholdToolTipOpen : isConcentrationToolTipOpen}
          onClickAway={data.value === 'Individual Households' ? handleHouseholdClickAway : handleConcentrationClickAway}
          disableHoverListener={true}
          disableFocusListener={true}
          aria-describedby={`${data.value}-tooltip`}
          data-testid={`${data.value}-tooltip`}
        >
          <StyledIconButton
            onClick={() => {
              if (data.value === 'Individual Households') {
                setIsHouseholdToolTipOpen(!isHouseholdToolTipOpen)
                setIsConcentrationToolTipOpen(false)
              } else {
                setIsConcentrationToolTipOpen(!isConcentrationToolTipOpen)
                setIsHouseholdToolTipOpen(false)
              }
            }}
            id={`${data.value}-tooltip`}
            aria-label={
              data.value === 'Individual Households' ? ariaLabelHouseholdToolTip : ariaLabelConcentrationToolTip
            }
            aria-controls={`${data.value}-tooltip`}
            aria-expanded={data.value === 'Individual Households' ? isHouseholdToolTipOpen : isConcentrationToolTipOpen}
            tabIndex={0}
          >
            <StyledErrorOutline />
          </StyledIconButton>
        </StyledTooltip>
      )}
    </StyledDiv>
  ))

  return (
    <>
      <StyledSectionTitle variant='h5'> {mainHeading} </StyledSectionTitle>
      <DataAggregationSubTitle>{subHeading}</DataAggregationSubTitle>
      <FormGroup>{aggregationList}</FormGroup>
      {isCompleted && selectedData?.length === 0 && <ErrorMessage>Data Aggregation cannot be empty</ErrorMessage>}
    </>
  )
}

export default DataAggregation
